import React, { ForwardedRef } from "react";
import clsx from "clsx";
import MuiIconButton from "@mui/material/IconButton";

import { IconButtonProps } from "./IconButton.types";
import { useStyles, useIconButtonStyles } from "./IconButton.styles";
import Tooltip from "../Tooltip";

function IconButton(
  props: IconButtonProps,
  ref: ForwardedRef<HTMLButtonElement>
) {
  const {
    rotate,
    children,
    className,
    size,
    disabled,
    onClick,
    disabledTooltip,
    tooltipAction,
    ...other
  } = props;

  const iconButtonClasses = useIconButtonStyles();

  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      return;
    } else {
      onClick?.(event);
    }
  };

  const rootClassName = clsx(className, {
    [classes.rotate]: rotate,
    [classes.sizeSmall]: size === "small",
    [classes.sizeTiny]: size === "tiny",
  });

  const button = (
    <MuiIconButton
      classes={iconButtonClasses}
      {...other}
      ref={ref}
      className={rootClassName}
      aria-disabled={!!disabled}
      onClick={handleClick}
    >
      {children}
    </MuiIconButton>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip title={disabledTooltip} action={tooltipAction}>
        {button}
      </Tooltip>
    );
  }

  return button;
}

export default React.forwardRef(IconButton);
